import { style } from 'typestyle'

/* Styles ======================================================================================= */
import { StyleClass } from '../../../components/style-class'

/* Types ======================================================================================== */
type ClassNames = {
  /**
   * Themed class for line
   */
  base: string
}

type ClassProps = any

const getNames: (props: any, theme: any) => ClassNames = (props, theme) => {
  const base = style({})

  return {
    base,
  }
}

/* Export ======================================================================================= */
export const headerClass = new StyleClass<ClassNames, ClassProps>(getNames)
